import { Injectable } from '@angular/core';

import { planosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import {newRoute, editRoute, configuracaoRoute} from "../../../shared/services/data.service";
import {manutencoesRoute} from "../../shared/data.service";

@Injectable()
export class PlanoNavigationService {

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = manutencoesRoute + '/' + configuracaoRoute + '/' + planosRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = manutencoesRoute + '/' + configuracaoRoute + '/' + planosRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = manutencoesRoute + '/' + configuracaoRoute + '/' + planosRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/planos/shared/plano-navigation.service.ts
 **/